import { Link } from 'react-router-dom';
import { FadeOutContainer, FadeOutSpacer, StyledOverflowTypography } from '../components';
import { useSidebarMenuCollapsible } from '../useSidebarMenuCollapsible';
import { SidebarMenuCollapsibleItemContainer } from './styled';
export function SidebarMenuCollapsibleItem(props) {
    const { to, label, active = false } = props;
    const { mode, open: collapsibleOpen, onChildClick } = useSidebarMenuCollapsible();
    return (<SidebarMenuCollapsibleItemContainer as={Link} to={to} onClick={onChildClick} tabIndex={!collapsibleOpen ? -1 : 0} $active={active} $isMenuChild={mode === 'menu'}>
      <FadeOutContainer $minimized={false}>
        <FadeOutSpacer>
          <StyledOverflowTypography $fontWeight="medium" $fontSize="small">
            {label}
          </StyledOverflowTypography>
        </FadeOutSpacer>
      </FadeOutContainer>
    </SidebarMenuCollapsibleItemContainer>);
}
